import { Container } from "react-bootstrap";
import NavBar from "./NavBar";

import ReactGA from "react-ga";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";
ReactGA.initialize("UA-185410468-1");

const Layout = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });
  return (
    <Container fluid dir="rtl" className='m-0 p-0'>
    <NavBar />
    <Container className="mx-auto" >
      {props.children}
    </Container>
    </Container>
  );
};

export default withRouter(Layout);
